import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../../../providers/appProvider";
import tbl from "../../../../assets/Style/Table.module.css";
import cl from "./List.module.css";
import Add from "../Add/Add";
import { useBooking } from "../../../../hooks/useBooking";
import { useBookingDetails } from "../../../../hooks/useBookingDetails";
import BookingEditModal from "../Edit/Edit";
import BookingDeleteModal from "../Delete/Delete";
import BookingCopyModal from "../Copy/Copy";
import { selectStyle } from "./selectStyle";
import Select from "react-select";
import BookingViewModal from "../View/View";
import { useSalesAmount } from '../../../../hooks/useSalesAmount';

const BookingList = () => {

    const initialTypeOptions = [
        //{ value: 0, label: ' ' },
        { value: 1, label: 'საზღვაო' },
        { value: 2, label: 'სახმელეთო' },
        { value: 3, label: 'სარკინიგზო' },
        { value: 4, label: 'საჰაერო' },
    ];

    const customsTypeOptions = [
        //{ value: 0, label: ' ' },
        { value: 1, label: 'იმპორტი' },
        { value: 2, label: 'ექსპორტი' },
        { value: 3, label: 'ტრანზიტი' },
        { value: 4, label: 'რეექსპორტი' },
    ];

    const statusTypes = [
        // { value: 0, label: ' ' },
        { value: 1, label: 'გაუქმებული' },
        { value: 2, label: 'გზაში' },
        { value: 3, label: 'დასრულებული' },
        { value: 4, label: 'მიმდინარე' },
    ];

    const tabs = [
        { value: 1, label: "აქტიური" },
        { value: 2, label: "არქივი" }
    ];


    const { appState, app } = useContext(AppContext);
    const { BookingService } = useBooking(50, true);
    const { BookingDetailsService } = useBookingDetails(50, true);
    const salers = appState.salers.map((user) => ({
        value: user.id,
        label: user.firstname + " " + user.lastname,
    }));
    const [receiverCities, setReceiverCities] = useState([]);
    const [receiverCountries, setReceiverCountries] = useState([]);
    const [senderCities, setSenderCities] = useState([]);
    const [senderCountries, setSenderCountries] = useState([]);
    const [currentTab, setCurrentTab] = useState([]);
    const {saleAmountService} = useSalesAmount()

    const [localBookings, setLocalBookings] = useState([]);
    
    useEffect(() => {
        BookingService.fetchList();
    }, []);

    useEffect(() => {
    let cancelled = false;

    const enhance = async (bookings) => {
        if (!Array.isArray(bookings) || bookings.length === 0) {
        if (!cancelled) setLocalBookings([]);
        return;
        }

        const enhanced = await Promise.all(
        bookings.map(async (booking) => {
            try {
            const salesRes = await BookingDetailsService.getByBookingId(booking.id);
            const sales = Array.isArray(salesRes?.booking_details) ? salesRes.booking_details : [];

            const salesAgentTotal = sales.reduce((sum, s) => sum + (Number(s?.agent_price) || 0), 0);
            const salesClientTotal = sales.reduce((sum, s) => sum + (Number(s?.client_price) || 0), 0);

            const cargoResults = await Promise.allSettled(
                sales.map((s) => saleAmountService.fetchBySaleId(s.id))
            );

            const allCargo = cargoResults.flatMap((r) => {
                if (r.status !== "fulfilled") return [];
                const v = r.value;
                if (Array.isArray(v)) return v;
                if (Array.isArray(v?.items)) return v.items;
                return [];
            });

            const totals = allCargo.reduce(
                (acc, item) => {
                const type = item?.sale_amount_type;
                const amt = Number(item?.amount) || 0;
                if (type === 1) acc.client += amt;       
                else if (type === 2) acc.company += amt; 
                return acc;
                },
                { client: 0, company: 0 }
            );

            return {
                ...booking,
                client_debt: salesClientTotal - totals.client,
                company_debt: salesAgentTotal - totals.company,
            };
            } catch (err) {
            console.error(`Error calculating debts for booking ${booking.id}`, err);
            return { ...booking, client_debt: 0, company_debt: 0 };
            }
        })
        );

        if (!cancelled) setLocalBookings(enhanced);
    };

    const snapshot = Array.isArray(BookingService.items) ? [...BookingService.items] : [];
    enhance(snapshot);

    return () => { cancelled = true; };
    }, [BookingService.items]);


    console.log(BookingService.items)

    useEffect(() => {
        const getCountryName = (countryId) => {
            const country = appState.countries.find(
                (country) => country.id === countryId
            );
            return country ? country.name : "";
        };
    
        const receiverCitiesData = Array.from(
            new Set(appState.prices.map((item) => item.reciever_city?.id))
        ).map((id) => {
            const city = appState.prices.find(
                (item) => item.reciever_city?.id === id
            )?.reciever_city;
            return {
                value: city.id,
                label: `${getCountryName(city.country_id)} ${city.name}`,
                countryId: city.country_id,
            };
        });
    
        const receiverCountriesData = Array.from(
            new Set(receiverCitiesData.map((city) => city.countryId))
        ).map((countryId) => {
            const country = appState.countries.find(
                (country) => country.id === countryId
            );
            return {
                value: country.id,
                label: country.name,
            };
        });
    
        const senderCitiesData = Array.from(
            new Set(appState.prices.map((item) => item.sender_city?.id))
        ).map((id) => {
            const city = appState.prices.find(
                (item) => item.sender_city?.id === id
            )?.sender_city;
            return {
                value: city.id,
                label: `${getCountryName(city.country_id)} ${city.name}`,
                countryId: city.country_id,
            };
        });
    
        const senderCountriesData = Array.from(
            new Set(senderCitiesData.map((city) => city.countryId))
        ).map((countryId) => {
            const country = appState.countries.find(
                (country) => country.id === countryId
            );
            return {
                value: country.id,
                label: country.name,
            };
        });
    
        setReceiverCities(receiverCitiesData);
        setReceiverCountries(receiverCountriesData);
    
        setSenderCities(senderCitiesData);
        setSenderCountries(senderCountriesData);
    }, [appState.countries, appState.prices]);

    const handleInputChange = (event) => {
        const { name, value } = event.target;

        BookingService.setFilter({
            ...BookingService.filter,
            [name]: value,
            page: 1,
        });
    };
    const onChangeTab = (val) => {
        setCurrentTab(val.value);
        switch (val.value) {
          case 1:
            BookingService.setFilter((prevState) => ({
              ...prevState,
              is_archive: false,
              page: 1,
            }));
            break;
          case 2:
            BookingService.setFilter((prevState) => ({
              ...prevState,
              is_archive: true,
              page: 1,
            }));
            break;
          default:
            BookingService.setFilter((prevState) => ({
              ...prevState,
              is_archive: false,
              page: 1,
            }));
        }
      };

    return(
        <div>
            <div className={cl.headMain}>
                <h1>ბუქინგი</h1>
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    {app.hasPermission("BOOKING_UPLOAD") && (
                        <>
                            <Add BookingService={BookingService} BookingDetailsService={BookingDetailsService}/>
                        </>
                    )}
                    </div>
            </div>
            <div className={cl.searchBox}>
                <div className={cl.col}>
                <div className={cl.inBox}>
                    <Select
                    styles={selectStyle}
                    options={tabs}
                    value={tabs.find((option) => option.value === currentTab)}
                    onChange={onChangeTab}
                    placeholder="სტატუსი"
                    />
                </div>
                </div>
            </div>
            <div 
                className={tbl.table + " " + cl.table}
                style={{ height: "calc(100vh - 158px)", background: "white" }}
            >
                
                <table>
                    <thead>
                        <tr>
                            
                            <th className={cl.id}>
                            <input
                                style={{ minWidth: '67px', textAlign: 'center', backgroundColor: 'transparent' }}
                                name="Booking_id"
                                placeholder="ID"
                                value={BookingService.filter.id}
                                onChange={handleInputChange}
                            />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={salers}
                                    value={salers.find(
                                    (option) => option.value === BookingService.filter.saler_id
                                    )}
                                    onChange={(selectedOption) => {
                                    BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        saler_id: selectedOption ? selectedOption.value : 0,
                                        page: 1,
                                    }));
                                    }}
                                    isClearable
                                    placeholder="გაყიდვების მენეჯერი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={statusTypes}
                                    value={statusTypes.find(
                                    (option) => option.value === BookingService.filter.status_id
                                    )}
                                    onChange={(selectedOption) => {
                                    BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        status_id: selectedOption ? selectedOption.value : 0,
                                        page: 1,
                                    }));
                                    }}
                                    isClearable
                                    placeholder="სტატუსი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={salers}
                                    value={salers.find(
                                    (option) => option.value === BookingService.filter.user_id
                                    )}
                                    onChange={(selectedOption) => {
                                    BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        user_id: selectedOption ? selectedOption.value : 0,
                                        page: 1,
                                    }));
                                    }}
                                    isClearable
                                    placeholder="მომხმარებელი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={senderCountries}
                                    value={senderCountries.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.sender_country_id
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        sender_country_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="ჩატვირთვის ქვეყანა"
                                />
                            </th>
                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={senderCities}
                                    value={senderCities.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.sender_city_id
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        sender_city_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="დატვირთვის ქალაქი"
                                />
                            </th>
                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={receiverCountries}
                                    value={receiverCountries.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.reciever_country_id
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        reciever_country_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="დაცლის ქვეყანა"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={receiverCities}
                                    value={receiverCities.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.reciever_city_id
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        reciever_city_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="დაცლის ქალაქი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={customsTypeOptions}
                                    value={customsTypeOptions.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.customsOption
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        cutsoms_type_option: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="საბაჟოს ტიპი"
                                />
                            </th>

                            <th className={cl.pad2}>
                                <Select
                                    styles={selectStyle}
                                    options={initialTypeOptions}
                                    value={initialTypeOptions.find(
                                        (option) =>
                                        option.value ===
                                        BookingService.filter.type_id
                                    )}
                                    onChange={(selectedOption) => {
                                        BookingService.setFilter((prevState) => ({
                                        ...prevState,
                                        type_id: selectedOption ? selectedOption.value : 0,
                                        }));
                                    }}
                                    isClearable
                                    placeholder="გადაზიდვის ტიპი"
                                />
                            </th>

                            <th className={cl.id}>კომპანიის დავალიანება</th>
                            <th className={cl.id}>კლიენტის დავალიანება</th>
                            <th className={cl.id}>შექმნა</th>
                            <th className={cl.id}>განახლება</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {localBookings != null ? (

                        localBookings.map((q) => (
                            <tr key={q.id}> {/* Don't forget to add a unique key prop */}
                                <td style={{textAlign: 'center'}}>{q.booking_id} {q.quotation != null ? "- " + q.quotation.quotation_id : ''}</td>
                                <td>{q.seller.firstname + ' ' + q.seller.lastname}</td>
                                <td>
                                    {statusTypes && statusTypes.length > 0
                                        ? statusTypes.find(option => option.value === q.status_id)?.label || 'Unknown'
                                        : 'სტატუსი არ არის მინიჭებული'}
                                </td>
                                {/* <td>{q.user.firstname + ' ' + q.user.lastname}</td> */}
                                <td>
                                    {q.user ? q.user.firstname + ' ' + q.user.lastname : 'მომხმარებელი'}
                                </td>
                                <td>
                                    {appState.countries && appState.countries.length > 0
                                        ? appState.countries.find(option => option.id === q.sender_country_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {appState.cities && appState.cities.length > 0
                                        ? appState.cities.find(option => option.id === q.sender_city_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {appState.countries && appState.countries.length > 0
                                        ? appState.countries.find(option => option.id === q.reciever_country_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {appState.cities && appState.cities.length > 0
                                        ? appState.cities.find(option => option.id === q.reciever_city_id)?.name || 'Unknown'
                                        : 'ქვეყანა არ არის მინიჭებული'}
                                </td>
                                <td>
                                    {customsTypeOptions && customsTypeOptions.length > 0
                                        ? customsTypeOptions.find(option => option.value === q.custom_id)?.label || 'Unknown'
                                        : 'საბაჟო არ არის მინიჭებული'}
                                </td>    
                                <td>
                                    {initialTypeOptions && initialTypeOptions.length > 0
                                        ? initialTypeOptions.find(option => option.value === q.type_id)?.label || 'Unknown'
                                        : 'სტატუსი არ არის მინიჭებული'}
                                </td>
                                {/* დავალიანება */}
                                <td>{q.company_debt}$</td>
                                <td>{q.client_debt}$</td>
                                <td>{new Date(q.created_at).toLocaleString()}</td>
                                <td>{new Date(q.updated_at).toLocaleString()}</td>
                                <td className={cl.btntbl}>
                                    <div className={cl.btns}>
                                        <>
                                            <BookingEditModal
                                                BookingService={BookingService}
                                                BookingDetailsService={BookingDetailsService}
                                                defaultBooking={q}
                                            />
                                            <BookingViewModal
                                                BookingService={BookingService}
                                                BookingDetailsService={BookingDetailsService}
                                                defaultBooking={q}
                                            />
                                            <BookingDeleteModal
                                                BookingService={BookingService}
                                                BookingDetailsService={BookingDetailsService}
                                                defaultBooking={q}
                                            />
                                            <BookingCopyModal
                                                BookingService={BookingService}
                                                BookingDetailsService={BookingDetailsService}
                                                defaultBooking={q}
                                            />
                                        </>
                                    </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="13" style={{textAlign: 'center'}}>No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    )
}

export default BookingList;